import { Navigate, useOutletContext, useSearchParams } from "react-router-dom";

import ExperienceIndexAnswersTab from "../_ExperienceIndexAnswersTab";
import type { CareerProfileQueryResult } from "../_useCareerProfileQuery";
import { careerPlanCompetencyIdFromSearch, careerProfileExperienceIndexHref } from "../careerPlanLatest";

export default function CareerProfileExperienceIndexAssessmentPage() {
  const [searchParams] = useSearchParams();
  const { pgaId, assessment, competencies } = useOutletContext<CareerProfileQueryResult>();
  const competencyId = careerPlanCompetencyIdFromSearch(searchParams);

  if (!pgaId) return null;
  if (!competencyId) {
    return <Navigate to={careerProfileExperienceIndexHref(pgaId)} replace />;
  }

  return (
    <ExperienceIndexAnswersTab
      answers={assessment?.answers ?? []}
      competencies={competencies}
      focusedCompetencyId={competencyId}
    />
  );
}
